export default {
  all: 'All',
};
